import { Link } from "react-router-dom";
import { Card, CardContent } from "@learn-me/ui";
import {
  OFFERING_CTA_LABELS,
  OFFERING_FOCUS_LABELS,
  type TrainingOffering,
} from "@learn-me/types";
import { Clock, MapPin, ArrowRight } from "lucide-react";

export function OfferingCard({ offering }: { offering: TrainingOffering }) {
  return (
    <Card className="h-full flex flex-col hover:shadow-lg transition-shadow">
      <CardContent className="p-6 flex flex-col h-full">
        <h3 className="font-display text-lg font-bold text-secondary-900 mb-3">
          {offering.title}
        </h3>

        <p className="text-sm text-secondary-600 leading-relaxed mb-5">
          {offering.summary}
        </p>

        <div className="mb-5">
          <p className="text-xs font-semibold uppercase tracking-wide text-secondary-500 mb-2">
            {OFFERING_FOCUS_LABELS[offering.category]}
          </p>
          <div className="flex flex-wrap gap-1.5">
            {offering.focusAreas.map((area) => (
              <span
                key={area}
                className="px-2.5 py-1 bg-primary-50 text-primary-700 text-xs rounded-full"
              >
                {area}
              </span>
            ))}
          </div>
        </div>

        <div className="space-y-2 text-sm text-secondary-600 mb-6">
          <p className="flex items-center gap-2">
            <Clock className="h-4 w-4 text-secondary-400 flex-shrink-0" />
            {offering.durationLabel}
          </p>
          <p className="flex items-start gap-2">
            <MapPin className="h-4 w-4 text-secondary-400 flex-shrink-0 mt-0.5" />
            <span>{offering.modalities.join(" · ")}</span>
          </p>
        </div>

        <Link
          to={`/programas/${offering.slug}`}
          className="mt-auto inline-flex items-center justify-center gap-2 w-full px-4 py-2.5 rounded-lg bg-secondary-900 hover:bg-secondary-800 text-white text-sm font-semibold transition-colors"
        >
          {OFFERING_CTA_LABELS[offering.category]}
          <ArrowRight className="h-4 w-4" />
        </Link>
      </CardContent>
    </Card>
  );
}
